export const expandDataItem = event => {
  const clickedElement = event.target;
  const isTd = clickedElement.tagName === 'TD';

  if (isTd) {
    toggleExpanded(clickedElement);
    return;
  }

  toggleExpanded(clickedElement.parentElement);
};

const toggleExpanded = element => {
  const isExpanded = element.classList.contains('expanded');
  isExpanded
    ? element.classList.remove('expanded')
    : element.classList.add('expanded');
};
